import Box from 'components/elements/Box';
import React from 'react';
import moment from 'moment';
import {
  FooterWrapper,
  FooterButton,
  Line,
  Circle,
  InfoText,
} from './shared.styles';

interface IDateRangeFooterProps {
  onSave: () => void;
  onReset: () => void;
  onClose: () => void;
  onClear: () => void;
  canSave: boolean;
  isSmallScreen: boolean;
  firstAvailableDate: moment.Moment;
  withPeriod?: boolean;
}

const DateRangeFooter: React.FC<IDateRangeFooterProps> = ({
  onSave,
  onReset,
  canSave,
  onClose,
  onClear,
  isSmallScreen,
  firstAvailableDate,
  withPeriod,
}) => {
  const isInCurrentYear = moment().year() === moment(firstAvailableDate).year();
  return (
    <>
      {withPeriod && (
        <Box display="flex" justifyContent="center" alignItems="center" my={4}>
          <Circle />
          <InfoText>
            {' '}
            ={' '}
            {isInCurrentYear
              ? moment(firstAvailableDate).format('MMM D')
              : moment(firstAvailableDate).format('MMM D, YYYY')}{' '}
            first day with available data
          </InfoText>
        </Box>
      )}
      <Line />
      <FooterWrapper isMobile={isSmallScreen}>
        {isSmallScreen && (
          <FooterButton
            mr={2}
            variant="secondary"
            type="button"
            onClick={onClose}
          >
            Cancel
          </FooterButton>
        )}
        {withPeriod && (
          <FooterButton
            mr={2}
            variant="secondary"
            type="button"
            onClick={onClear}
          >
            Clear
          </FooterButton>
        )}
        <FooterButton
          mr={2}
          variant="secondary"
          type="button"
          onClick={onReset}
        >
          Reset
        </FooterButton>
        <FooterButton
          variant={canSave ? 'primary' : 'disabled'}
          disabled={!canSave}
          type="button"
          onClick={onSave}
        >
          Save
        </FooterButton>
      </FooterWrapper>
    </>
  );
};

export default DateRangeFooter;
